<template>
  <div style="width:257px">
    <a-select
      v-model="value"
      showSearch
      :mode="multiple ? 'multiple' : 'default'"
      style="width: 98%"
      optionFilterProp="children"
      :maxTagTextLength="17"
      :maxTagCount="1"
      :placeholder="$t('filter_by_academicYear')"
      :options="
        options.map(el => ({
          value: el.ac_year_id,
          id: el.ac_year_id,
          label: el.ac_year
        }))
      "
      :filterOption="
        (input, option) =>
          option.componentOptions.children[0].text
            .toLowerCase()
            .indexOf(input.toLowerCase()) >= 0
      "
      @change="changeValue"
    />
  </div>
</template>

<script>
export default {
  name: 'academicYearFilter',
  props: {
    multiple: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      value: [],
      options: []
    }
  },
  created() {
    this.fetchYear()
  },
  methods: {
    fetchYear() {
      this.$store
        .dispatch('academicYear/fetch', {
          page: -1,
          fields: {
            academic_years: 'ac_year_id,ac_year'
          }
        })
        .then(response => {
          this.options = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    changeValue() {
      this.$emit('filter', this.value)
    }
  }
}
</script>
<style lang="css" scoped>
.vue-treeselect__control {
  height: 34px !important;
}
</style>
